export default __webpack_public_path__ + "static/media/bootstrap-grid.min.css.a26b865b.map";